<template>
  <div class="bread">
    <!-- 环形图表格 -->
    <template v-if="tableData.length > 0">
      <div
        id="annularChart"
        ref="annular"
        class="annularChart"
        :style="{width: isMobile ? '355px' : '100%', height: isMobile ? (h + 'px') : '100%'}"></div>
    </template>

    <template v-if="tableData.length === 0">
      <div class="nodata">
        <span>
          <img src="https://bigdata.topeti.com/PCRepository/defaultSvg/Intersect.svg" />
          <div>暂无数据</div>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import macaronsDatas from './json/echartColor.json'
import { colorData } from './js/color.js';
import { echartTemp } from '@/components/common/echartsBuilder/template/annularDetails.js'
let chartsModel = "";
// var curInt = null;


export default {
  name: 'annularDetails',
  props: {
    h: Number,
    isMobile: {
      type: Boolean,
      default: false
    },
    //- 分组字段数据
    row: {
      type: Array,
      default: () => []
    },
    //- 汇总字段数据
    summary: {
      type: Array,
      default: () => []
    },
    //- drage组件大小修改后，饼图实时更新
    changeSize: {
      type: Number,
      default: 0
    },
    //- 表格数据
    tableData: {
      type: Array,
      default: () => []
    },
    //- 表id
    id: {
      type: Number,
      default: 0
    },
    // 图形样式
    echartsTempId: {
      type: Number,
      default: -1
    },
    //- isFrontEnd是否为前端或者后端展示:true为后端,false为前端
    isFrontEnd: {
      type: Boolean,
      default: () => false
    },
    viewShow: {
      type: Boolean,
      default: () => false
    },
    selectIndex: {
      type: Number,
      default: () => null
    },
    user: {
      type: Array,
      default: () => []
    },
    width: [String, Number],
    theme: Object
  },
  data: function () {
    return {
      myChart: '',
      nameArray: [],
      chartOption: {},
      echartsDataArr: [],
      resizeObserver: null,
      isChartInitialized: false,
    }
  },
  mounted () {
    console.log("this.selectIndex==>", this.selectIndex);
    // if(this.selectIndex){
    //     curInt = this.selectIndex;
    // }
    this.$nextTick(() => {
      this.setupResizeObserver();
      this.openFunBread();
    })
  },
  beforeUnmount () {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  methods: {
    setupResizeObserver () {
      const dom = this.$refs.annular;
      if (!dom) return;
      
      this.resizeObserver = new ResizeObserver(() => {
        if (this.isChartInitialized && this.myChart) {
          this.myChart.resize();
        }
      });
      this.resizeObserver.observe(dom);
    },
    updateFun () {
      console.log("更新");
      if (this.myChart && this.myChart.resize) {
        this.myChart.resize();
      }
    },
    //- 打开图表
    openFunBread () {
      if (this.tableData.length <= 25 && this.tableData.length > 0) {
        this.$nextTick(() => {
          this.initData();
        })

      }

    },
    // series 值动态计算
    getSeries () {
      const series = []
      const seriesType = this.tableData[0].seriesType
      if(seriesType === 'name'){
        this.echartsDataArr = this.tableData
        if (this.theme && this.theme.axes) {
          const themeVal = this.theme
          series.push({
            data: this.tableData,
            name: '访问来源',
            type: 'pie',
            center: ['50%', '60%'],
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: 'outside',
              formatter: function (param) {
                const maxCharsPerLine = themeVal.singleCount != 0 ? themeVal.singleCount : 100;
                const name = param.name;
                let wrappedText = '';
                for (let i = 0; i < name.length; i += maxCharsPerLine) {
                  wrappedText += name.substr(i, maxCharsPerLine) + '\n';
                }
                return wrappedText.trim() + '\n\n' + (themeVal && themeVal.tagTextList.indexOf('value') !== -1 ? param.value : '') + (themeVal && themeVal.tagTextList.indexOf('percent') !== -1 ? '(' + param.percent + '%)' : '');
              },
            },
            emphasis: {
              label: {
                show: this.theme.summaryShow || true,
                fontSize: this.theme.summaryFontSize,
                color: this.theme.summaryColor,
                fontFamily: this.theme.summaryFontFamily,
              }
            },
            labelLine: {
              show: !this.isMobile
            }
          })
        } else {
          series.push({
            data: this.tableData,
            name: '访问来源',
            type: 'pie',
            center: ['50%', '60%'],
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center',
              formatter: function (param) {
                return param.name + '\n\n' + param.value + '(' + param.percent + '%)';
              },
            },
            emphasis: {
              label: {
                show: false
              }
            },
            labelLine: {
              show: !this.isMobile
            },
            itemStyle: {
              borderRadius: 5,
              emphasis: {
                shadowBlur: 2,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              },
              borderWidth:2, //设置border的宽度有多大
              borderColor:'#fff',
              color: function (params) {
                return colorData(params.dataIndex);
              }
            }
          })
        }
      }
      else{
        for (const i of this.summary) {
          const arr = this.tableData.map(its => {
            return {
              value: its[i.title],
              name: its.name
            }
          })
          this.echartsDataArr = arr
          if (this.theme && this.theme.axes) {
            console.log("this.theme==",this.theme)
            const themeVal = this.theme
            series.push({
              data: arr,
              name: '访问来源',
              type: 'pie',
              center: ['50%', '60%'],
              radius: ['50%', '70%'],
              avoidLabelOverlap: false,
              label: {
                show: true,
                position: 'outside',
                alignTo: 'edge',
                formatter: function (param) {
                  const maxCharsPerLine = themeVal.singleCount != 0 ? themeVal.singleCount : 100;
                  const name = param.name;
                  let wrappedText = '';
                  for (let i = 0; i < name.length; i += maxCharsPerLine) {
                    wrappedText += name.substr(i, maxCharsPerLine) + '\n';
                  }
                  return wrappedText.trim() + '\n\n' + (themeVal && themeVal.tagTextList.indexOf('value') !== -1 ? param.value : '') + (themeVal && themeVal.tagTextList.indexOf('percent') !== -1 ? '(' + param.percent + '%)' : '');
                },
              },
              emphasis: {
                label: {
                  show: this.theme.summaryShow || true,
                  fontSize: this.theme.summaryFontSize,
                  color: this.theme.summaryColor,
                  fontFamily: this.theme.summaryFontFamily,
                }
              },
              labelLine: {
                show: !this.isMobile
              }
            })
          } else {
            series.push({
              data: arr,
              name: '访问来源',
              type: 'pie',
              center: ['50%', '60%'],
              radius: ['50%', '70%'],
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: 'center',
                formatter: function (param) {
                  return param.name + '\n\n' + param.value + '(' + param.percent + '%)';
                },
              },
              emphasis: {
                label: {
                  show: false,
                }
              },
              labelLine: {
                show: !this.isMobile
              },
              itemStyle: {
                borderRadius: 5,
                emphasis: {
                  shadowBlur: 2,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                },
                borderWidth:2, //设置border的宽度有多大
                borderColor:'#fff',
                color: function (params) {
                  return colorData(params.dataIndex);
                }
              }
            })
          }
        }
      }
      console.log('环形图series-->',series);
      return series
    },

    //- 创建图表
    initData () {
      console.log('创建图表获取主题配置数据', this.theme)
      const that = this;
      let nameArray = that.tableData.map(val => {
        return val.name
      })

      chartsModel = "";
      // that.tableData[0].selected = true;
      that.$nextTick(() => {
        // 基于准备好的dom，初始化echarts实例
        let dom = that.$refs.annular;
        if (!dom) return
        
        // 确保容器有实际尺寸，否则延迟重试
        if (dom.offsetWidth === 0 || dom.offsetHeight === 0) {
          setTimeout(() => {
            that.initData();
          }, 100);
          return;
        }
        
        echarts.registerTheme('macarons', macaronsDatas.theme)
        chartsModel = echarts.init(dom, 'macarons');


        let option = {
          tooltip: {
            trigger: 'item',
            formatter: "{b} : {c} ({d}%)"
          },
          title: {
            show: true, // 控制显隐
            left: 'center',
            top: 'center'
          },
          legend: {
            type: 'scroll',
            top: '0',
            left: 'right',
            data: nameArray,            
          },
/*
          legend: {
            type: 'scroll',
            bottom: '-5px',
            left: 'right',
            data: nameArray,
          },
*/
          series: this.getSeries()
/*
          series: [
            {
              name: '访问来源',
              type: 'pie',
              center: ['50%', '45%'],
              radius: ['50%', '70%'],
              avoidLabelOverlap: false,
              label: {
                show: !this.isMobile
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: '30',
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: !this.isMobile
              },
              itemStyle: {
                borderRadius: 5,
                emphasis: {
                  shadowBlur: 2,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                },
                borderWidth:2, //设置border的宽度有多大
                borderColor:'#fff',
                color: function (params) {
                  return colorData(params.dataIndex);
                  // return colorData(params.dataIndex, that.selectIndex);
                }
              },
              data: that.tableData
            }
          ]
*/
        };

        if (this.theme && this.theme.axes) {
          option.color = this.theme.color
/*
          option.legend.textStyle = {
            color: this.theme.legendTextColor
          }
*/
          option.legend = {
            type: 'scroll',
            top: '0',
            left: 'right',
            data: nameArray,
            show: this.theme.legendTextShow || true,
            textStyle: {
              color: this.theme.legendTextColor,
              fontSize: this.theme.legendTextFontSize,
              fontFamily: this.theme.legendTextFontFamily
            }
          }
          option.legend.top = this.theme.legendPosition
        }

        chartsModel.clear();
        // 绘制图表
        
        if(JSON.stringify(this.chartOption) === '{}' || this.chartOption === undefined){
          console.log("111");
          
          chartsModel.setOption(option);
        }
        else{
          console.log("222");
          if(this.echartsTempId === 0){
            const that = this
            // 数据绑定
            let all = 0;
            const list = this.echartsDataArr;
            list.forEach(function(item){
                all += item.value;
            })
            this.chartOption.title.text = all
            this.chartOption.legend.data = list
            this.chartOption.series[0].data = list
            this.chartOption.legend = {
              orient: 'vertical',
              right: '5%',
              align: 'left',
              top: 'middle',
              itemWidth: 13,
              itemHeight: 13,
              icon: 'circle',
              itemGap: 20,
              data: list,
              show: that.theme.legendTextShow,
              formatter: function (name) {
                // console.log('name--', name);
                var res = '';
                for (var i = 0; i < list.length; i++) {
                  if (list[i].name == name) {
                    res += '{a|' + name + '}'+ '{b|' + list[i].value + '}';
                  }
                }
                return res;
              },
              textStyle: {
                color: '#000',
                rich: {
                  a: {
                    fontSize: that.theme.legendTextFontSize,
                    fontFamily: that.theme.legendValueFontFamily,
                    color: that.theme.legendTextColor,
                    padding: [0, 10, 0, 6],
                  },
                  b: {
                    fontSize: that.theme.legendValueFontSize,
                    fontFamily: that.theme.legendTextFontFamily,
                    color: that.theme.legendValueColor,
                    padding: [0, 6, 0, 6],
                  },
                },
              }
            }
            console.log("this.chartOption.legend==",this.chartOption.legend);
            
          }
          chartsModel.setOption(this.chartOption);
        }
        chartsModel.off("click");
        chartsModel.on("click", (param) => {
          //- 设置环形图点击事件
          if (that.isFrontEnd === true) {
            return;
          }
          console.log("环形图点击=====>", param);


          that.relevanceFun(param.name, param.value, param.dataIndex);
        });
        that.myChart = chartsModel;
        that.isChartInitialized = true;
        that.$forceUpdate();
      })
    },
    //- 饼图点击事件，在客户端时候需要筛选查询该表单设置的对应关联表单
    relevanceFun (name, val, index) {
      if (this.isFrontEnd === true) {
        return;
      }
      let rowName = this.row[0].name;
      let summaryName = this.summary[0].name;
      let array = {};
      const nameArr = name ? name.split(/\1{1}/g) : name;
      if (Array.isArray(nameArr)) {
        for (let i = 0; i < this.row.length; i++) {
          array[this.row[i].name] = nameArr[i]
        }
      } else {
        array[rowName] = nameArr;
      }
      array[summaryName] = val;
      let date = {
        id: this.id,
        value: array,
        selectIndex: index
      }
      if (this.user[index]) date.user = this.user[index]
      this.$emit("relevanceFun", date)
    },
    // 主题切换,配色同时变化
    changeTheme(){
      if(this.echartsTempId === 0){
        console.log("this.chartOption===",this.chartOption);
        this.chartOption.title.show = this.theme.summaryShow
        if(!this.theme.summaryShow){
          this.chartOption.title.text = ''      
        }
        else{
          this.chartOption.title.textStyle.color = this.theme.summaryColor
          this.chartOption.title.textStyle.fontFamily = this.theme.summaryFontFamily
          this.chartOption.title.textStyle.fontSize = this.theme.summaryFontSize
        }
        if(!this.theme.summaryTextShow){
          this.chartOption.title.subtext = ''
        }
        else{
          this.chartOption.title.subtext = this.theme.summaryText
          this.chartOption.title.subtextStyle.color = this.theme.summaryTextColor
          this.chartOption.title.subtextStyle.fontFamily = this.theme.summaryTextFontFamily
          this.chartOption.title.subtextStyle.fontSize = this.theme.summaryTextFontSize
        }
        this.chartOption.series[0].color = this.theme.color        
        
      }
      
    }




  },
  watch: {
    changeSize (val) {
      console.log("w===>", val)
      if (this.tableData.length > 0) {
        setTimeout(() => {
          this.updateFun();

        }, 1000);

      }

    },
    theme: {
      immediate: true,
      deep: true,
      handler () {
        console.log('配置更新')
        if(this.echartsTempId !== -1 && this.echartsTempId !== null){
          this.chartOption = echartTemp[this.echartsTempId]
          this.changeTheme()
        }
        this.initData();
      }
    },
    echartsTempId: {
      immediate: true,
      handler (val) {
        console.log('图形样式',val)
        if(val === -1){
          this.chartOption = {}
        }
        else{
          this.chartOption = echartTemp[val]
          if(val === 0){
            console.log("this.theme==",this.theme);
            this.changeTheme()
          }
        }
        this.initData();
      }
    },
    'tableData': {
      handler (newV) {
        // do something, 可使用this
        console.log(newV)
        if (newV && newV.length > 0) {
          this.$nextTick(() => {
            this.$forceUpdate();
            this.openFunBread();
          })
        }

      },
      deep: true

    },
    'selectIndex': {
      handler (newName) {

        console.log("变话了", newName)
        this.$nextTick(() => {
          this.$forceUpdate();
          this.initData();
        })
      },
      deep: true
    },
    viewShow: {
      immediate: true,
      handler () {
        this.updateFun()
      }
    },
    width: {
      immediate: true,
      handler () {
        this.updateFun()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.bread {
  width: 100%;
  height: calc(100% - 10px);
  position: relative;
}
.nodata {
  width: 100%;
  text-align: center;
  color: #666666;
  //line-height: 244px;
  height: 100%;
  position: relative;
  span {
    display: inline-block;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    margin-left: -29px;
  }
}
</style>
